module.exports = __webpack_public_path__ + "static/media/Daikin_ZeroPoint.4bb5aab2.png";